module.exports = __webpack_public_path__ + "img/11-sdg-border@2x.f001d758.png";